import axiosInstance from "utils/axiosInstance";
import { storage } from 'utils/storage';

export const fetchTags = async () => {
    try {
        const response = await axiosInstance.get(`/api/tags`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching tags:', error);
        return [];
    }
};


export function getTagsListSettings() {
    const settings = storage.get('settings');
    
    return {
        'section': 'tags',
        'items': {
            'displayGroups': {
                'label': 'Display groups',
                'type': 'switch',
                'checked': settings.tags.displayGroups
            },
        }
    };
};
